<template>
  <button
    @click="$emit('clickBtn')"
    :disabled="disabled"
    class="text-black text-right disabled:cursor-not-allowed disabled:opacity-50 text-base font-[400] whitespace-nowrap border cursor-pointer shadow-[0px_0px_0px_2px_rgba(0,0,0,0.2)] bg-white justify-center items-stretch rounded-[30px] border-solid border-black"
    :class="[props.classList]"
  >
    <img
      :src="require('@/assets/icons/svg/' + props.icon)"
      v-if="props.icon"
      :alt="props.text"
      class="aspect-square object-contain object-center w-6 overflow-hidden shrink-0 max-w-full"
    />
    <div
      class="text-mainBlack-1000 text-base text-center font-[400] self-center my-auto"
    >
      {{ props.text }}
    </div>
  </button>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  icon: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: "button",
  },
  classList: {
    type: [String],
    default: "px-[25px] py-[8.2px]",
  },
});
</script>
